import React, { useState } from "react";
import { Modal } from "../../components";
import { useNavigate } from "react-router-dom";
import PrivacyPolicy from "../Settings/AboutUs/PrivacyPolicy";

const PrivacyPolicyModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const navigate = useNavigate();
  return (
    <Modal
      modalDescriptionClasses={"!contents"}
      customStyle="!show-scrollbar !max-h-full !rounded-none lg:!max-h-[88dvh] !p-6 lg:!p-8 !gap-4 w-full lg:!max-w-[78vw] !max-w-full lg:!rounded-lg"
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        navigate("/login");
      }}
    >
      <PrivacyPolicy classname="!p-0 lg:!max-h-[88dvh]" />
    </Modal>
  );
};

export default PrivacyPolicyModal;
